export default __webpack_public_path__ + "static/media/b40.bfe75b15.png";